import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";

import getActivePartners from "../services/partners/getActivePartners";

export const listActivePartners = createAsyncThunk(
  "activePartners/list",
  getActivePartners.handler,
);

const initialState = {
  lists: [],
  loading: false,
};

const slice = createSlice({
  name: "activePartners",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        listActivePartners.pending,
        getActivePartners.pending,
      )
      .addCase(
        listActivePartners.fulfilled,
        getActivePartners.fulfilled,
      )
      .addCase(
        listActivePartners.rejected,
        getActivePartners.rejected,
      );
  },
});

export default slice.reducer;
